import { getService } from '../../utils';

export const getEquipmentService = getService('equipment');
